<template>
  <div style="margin-top:30px">
    <tabla  Titulo="Catalogo" :Cabecera="Cabecera" :Items="Items" :Excel="false" :Crear="true" />
  </div>
</template>
<script>
import tabla from "@/components/producto/tabla.vue"
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Producto",
  components : {
    tabla
  },
  created(){
    const data = {menu1:-1,menu2:2,submenu2:2,menu3:0,submenu3:0};
    this.CargarMenu(data);
    this.cargarProducto();
  },
  data(){
    return{
      Cabecera:[
        {text:'Id',value:'id'},
        {text:'Tipo',value:'TIP_Nombre'},
        {text:'Nombre',value:'PRO_Nombre'},
        {text:'Color',value:'PRO_Color'},
        {text:'Encaje',value:'PRO_Encaje'},
        {text:'Tela',value:'PRO_Tipo_Tela'},
        {text:'Accion',value:'Accion'}
      ]
    }
  },
  methods:{
    ...mapActions('producto',['cargarProducto']),
    ...mapActions('nav',['CargarMenu'])
  },

  computed:{
    ...mapGetters('producto',['Items'])    
  }


};
</script>




